var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H13V10H12V12H10V13H12V15H13V13H15V12Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H4V1.99999H8V4.99999C8.00079 5.26496 8.1064 5.51885 8.29377 5.70622C8.48113 5.89358 8.73503 5.9992 9 5.99999H12V7.99999H13V4.99999C13.0018 4.93428 12.9893 4.86896 12.9634 4.80854C12.9375 4.74812 12.8988 4.69403 12.85 4.64999L9.35 1.14999C9.30598 1.10116 9.25189 1.06246 9.19147 1.03657C9.13104 1.01067 9.06572 0.998189 9 0.999987H4C3.73503 1.00078 3.48113 1.10639 3.29377 1.29375C3.1064 1.48112 3.00079 1.73501 3 1.99999V14C3.00079 14.265 3.1064 14.5189 3.29377 14.7062C3.48113 14.8936 3.73503 14.9992 4 15H8V14ZM9 2.19999L11.8 4.99999H9V2.19999Z",
    fill: "#344054"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.c7bc96237ad141515bf7a716fefb4715.svg";
export { ForwardRef as ReactComponent };